import { Box, Grid, Typography } from "@material-ui/core";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import { FreeTrialDialog } from "components/shared/free-trial-dialog/free-trial-dialog";
import { useState } from "react";
import { useSelector } from "react-redux";
import { GetUrlBuilderData } from "store/url-builder";
import hoverStyle from "styles/hover-overlay.module.scss";
import { EditInformationDialog } from "./edit-information-dialog";
import style from "./information.module.scss";

export interface InformationProps {
  builderType: string;
  isFree?: boolean | null;
}

export const Information = ({ builderType, isFree = null }: InformationProps) => {
  const builderData = useSelector(GetUrlBuilderData);
  const [informationDialog, setInformationDialog] = useState(false);
  const [freeTrialDialog, setFreeTrialDialog] = useState(false);

  const hasPopulatedValue = (value?: string | null) =>
    typeof value === "string" && value.trim().length > 0;

  const hasExistingInformation =
    hasPopulatedValue(builderData.info?.location) ||
    hasPopulatedValue(builderData.info?.calendar) ||
    (builderData.info?.links ?? []).some(
      ({ title, url }) => hasPopulatedValue(title) || hasPopulatedValue(url)
    );

  const openInformationDialog = () => setInformationDialog(true);
  const handleCloseInformationDialog = () => setInformationDialog(false);

  const openFreeTrialDialog = () => setFreeTrialDialog(true);
  const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);

  return (
    <Box className={hoverStyle.root} width="100%" display="flex">
      <Grid item container xs={12} className={style.informationList}>
        <Grid item container xs={12} justifyContent="space-between">
          <Typography
            variant="subtitle2"
            color="textPrimary"
            className={style.wrapIcon}
          >
            <DateRangeIcon style={{ color: builderData.primaryColor.color }} />{" "}
            <b>Calendar</b>
          </Typography>

          <Typography
            variant="subtitle2"
            color="textPrimary"
            className={style.wrapIcon}
          >
            <LinkOutlinedIcon
              style={{ color: builderData.primaryColor.color }}
            />{" "}
            <b>Links</b>
          </Typography>
          <Typography
            variant="subtitle2"
            color="textPrimary"
            className={style.wrapIcon}
          >
            <RoomOutlinedIcon
              style={{ color: builderData.primaryColor.color }}
            />{" "}
            <b>Navigate</b>
          </Typography>
        </Grid>
      </Grid>
      <Grid
        onClick={!isFree ? openInformationDialog : openFreeTrialDialog}
        item
        xs={12}
        className={hoverStyle.root_content}
      >
        <Typography
          variant="subtitle2"
          className="d-flex aling-items_center"
          color="textSecondary"
        >
          <EditOutlinedIcon fontSize="small" />
          <b>
            {hasExistingInformation ? "Add/Edit Information" : "Add Information"}
          </b>
        </Typography>
      </Grid>
      {informationDialog && (
        <EditInformationDialog
          isOpen={informationDialog}
          onClose={handleCloseInformationDialog}
          builderType={builderType}
        />
      )}
      {freeTrialDialog && (
        <FreeTrialDialog
          isOpen={freeTrialDialog}
          onClose={handleCloseFreeTrialDialog}
        />
      )}
    </Box>
  );
};
